/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateOrganizationRemoteSessionClientForm,
  CreateOrganizationRemoteSessionClientForm$Outbound,
  CreateOrganizationRemoteSessionClientForm$outboundSchema,
} from "../components/createorganizationremotesessionclientform.js";

export type CreateOrganizationRemoteSessionClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type CreateOrganizationRemoteSessionClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  createOrganizationRemoteSessionClientForm:
    CreateOrganizationRemoteSessionClientForm;
};

/** @internal */
export type CreateOrganizationRemoteSessionClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const CreateOrganizationRemoteSessionClientSecurity$outboundSchema:
  z.ZodMiniType<
    CreateOrganizationRemoteSessionClientSecurity$Outbound,
    CreateOrganizationRemoteSessionClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function createOrganizationRemoteSessionClientSecurityToJSON(
  createOrganizationRemoteSessionClientSecurity:
    CreateOrganizationRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    CreateOrganizationRemoteSessionClientSecurity$outboundSchema.parse(
      createOrganizationRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type CreateOrganizationRemoteSessionClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  CreateOrganizationRemoteSessionClientForm:
    CreateOrganizationRemoteSessionClientForm$Outbound;
};

/** @internal */
export const CreateOrganizationRemoteSessionClientRequest$outboundSchema:
  z.ZodMiniType<
    CreateOrganizationRemoteSessionClientRequest$Outbound,
    CreateOrganizationRemoteSessionClientRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      createOrganizationRemoteSessionClientForm:
        CreateOrganizationRemoteSessionClientForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        createOrganizationRemoteSessionClientForm:
          "CreateOrganizationRemoteSessionClientForm",
      });
    }),
  );

export function createOrganizationRemoteSessionClientRequestToJSON(
  createOrganizationRemoteSessionClientRequest:
    CreateOrganizationRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    CreateOrganizationRemoteSessionClientRequest$outboundSchema.parse(
      createOrganizationRemoteSessionClientRequest,
    ),
  );
}
